import { render } from "./Widget2.vue?vue&type=template&id=1fd4815e"
import script from "./Widget2.vue?vue&type=script&lang=ts"
export * from "./Widget2.vue?vue&type=script&lang=ts"
script.render = render

export default script